module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "padding-top-150 padding-bottom-150"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "new-arrival-list"
  }, [_c('sellpoint-list'), _vm._v(" "), _vm._m(4)], 1)])])]), _vm._v(" "), _vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "sticky"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/logo.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar ownmenu"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#nav-open-btn",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "nav-open-btn"
    }
  }, [_c('ul', {
    staticClass: "nav"
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-right"
  }, [_c('ul', {
    staticClass: "navbar-right"
  }, [_c('li', {
    staticClass: "dropdown user-acc"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "icon-user"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('h6', [_vm._v("HELLO! Jhon Smith")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("MY CART")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("ACCOUNT INFO")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("LOG OUT")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sub-bnr",
    attrs: {
      "data-stellar-background-ratio": "0.5"
    }
  }, [_c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h4', [_vm._v("230 Sellpoints")]), _vm._v(" "), _c('p', [_vm._v("Connect Businesses through their Sellpoints")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Start")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading text-center"
  }, [_c('h4', [_vm._v("popular sellpoints")]), _vm._v(" "), _c('span', [_vm._v("Connect with top popular sellpoints, see what they are selling and other offers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center margin-top-50"
  }, [_c('a', {
    staticClass: "btn btn-small btn-round",
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" SHOW MORE...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "about-footer"
  }, [_c('img', {
    staticClass: "margin-bottom-30",
    attrs: {
      "src": "static/assets/images/logo-foot.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Where you sell.")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-call-end"
  }), _vm._v(" 080000000000")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-envelope"
  }), _vm._v(" howtosell@sellpoint.ng")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-envelope"
  }), _vm._v(" howtobuy@sellpoint.ng")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "icon-envelope"
  }), _vm._v(" info@sellpoint.ng")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', [_vm._v("TOUR")]), _vm._v(" "), _c('ul', {
    staticClass: "link"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Sellpoints")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Find a Sellpoint")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Products")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Services")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Privacy Policy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Media ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', [_vm._v("INFO")]), _vm._v(" "), _c('ul', {
    staticClass: "link"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" How to sell")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" How to buy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Contact")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Support")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Career")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Shipping Options")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Knowledge Base")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', [_vm._v("TOP LIST")]), _vm._v(" "), _c('ul', {
    staticClass: "link"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Food")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Health")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Fashion")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Community")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#."
    }
  }, [_vm._v(" Events")])])])]), _vm._v(" "), _c('div', {
    staticClass: "rights"
  }, [_c('p', [_vm._v("©  2015 sellpoint All right reserved. ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_c('a', {
    staticClass: "go-up",
    attrs: {
      "href": "#wrap"
    }
  }, [_c('i', {
    staticClass: "lnr lnr-arrow-up"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a1a84e2"}!./src/pages/Sellpoints/template.html
// module id = 287
// module chunks = 0